/**
 * MembersLandingPage — https://members.hustlesuite.au/
 */
import { Link } from "react-router-dom";
import {
  User, Wallet, Calendar, Heart, Star, ArrowRight, Users,
} from "lucide-react";
import PlatformHeader from "@/components/PlatformHeader";
import SuiteFooter from "@/components/SuiteFooter";

const CARDS = [
  { icon: User,     title: "My profile",     to: "/account",                 desc: "Photo · interests · dietary · saved orders." },
  { icon: Wallet,   title: "Points wallet",  to: "/points",                  desc: "Balance, top-ups, and redemption history." },
  { icon: Calendar, title: "Upcoming events",to: "/hustlemeet/my-events",    desc: "Circles, dinners, walks — everything you're going to." },
  { icon: Heart,    title: "Matchmaker",     to: "/matchmaker",              desc: "1:1 introductions curated by our team." },
  { icon: Star,     title: "Rewards",        to: "/rewards",                 desc: "Perks unlocked by your points balance." },
  { icon: Users,    title: "Circles",        to: "/circles",                 desc: "Small in-person groups near you." },
];

export default function MembersLandingPage() {
  return (
    <div data-testid="members-landing" className="min-h-screen bg-[#FDFBF7] text-[#121614]">
      <PlatformHeader
        brand={{ name: "HustleSuite · Members", to: "/" }}
        showBookCta={false}
        showCart={false}
      />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <p className="text-xs uppercase tracking-[0.22em] font-bold text-[#5A7247]">
          Members portal
        </p>
        <h1 className="mt-2 font-serif-display text-4xl sm:text-5xl leading-tight">
          Everything a HustleMember cares about, one tap away.
        </h1>
        <p className="mt-3 text-[#3C423F] max-w-xl">
          Your profile, points, events, and matchmaker invites — all
          here. Vendors get a member account too; switch sides in
          Account.
        </p>
        <section className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CARDS.map(({ icon: Icon, title, to, desc }) => (
            <Link
              key={title}
              to={to}
              data-testid={`members-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white border border-[#E8E5DF] rounded-2xl p-5 hover:border-[#5A7247] hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-[#C05746]/10 text-[#C05746] flex items-center justify-center">
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <h3 className="mt-4 font-serif-display text-2xl">{title}</h3>
              <p className="mt-1.5 text-sm text-[#3C423F]">{desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#C05746] group-hover:gap-2 transition-all">
                Open <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          ))}
        </section>
      </main>
      <SuiteFooter />
    </div>
  );
}
